import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class NotesReport extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'created_at',
    'note',
    'status',
    'note_type',
    'date_booked',
    'check_in',
    'check_out',
    'reservation_id',
    'reservation_status',
    'reservation_ident',
    'reservation_source',
    'reservation_total',
    'user_name',
    'guest_id',
    'guest_name',
    'guest_email',
    'guest_phone',
    'guest_address',
    'guest_country',
    'guest_city',
    'room_type',
    'rooms',
    'nights',
)(NotesReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/daily-activity/notes.model.js